import { makeStyles } from 'tss-react/mui';

export const useStylesModalOffer = makeStyles()(theme => {
  return {
    dialogContent: {
      borderRadius: 40,
      padding: 27,
      backgroundColor: '#f2f2f7',
      [theme.breakpoints.down('sm')]: {
        padding: 16,
        borderRadius: 20,
      },
    },
    image: {
      height: 232,
      width: 232,
      objectFit: 'contain',
      marginRight: 24,
      borderRadius: 8,

      [theme.breakpoints.down('md')]: {
        height: 60,
        width: 60,
      },
    },
    edit: {
      marginTop: 10,
      textTransform: 'inherit',
      height: 48,
      fontSize: 17,
      fontWeight: theme.typography.fontWeightRegular,
      color: '#fff',
      width: 180,

      [theme.breakpoints.down('md')]: {
        height: 40,
        width: 100,
        fontSize: 12,
      },
    },
    editBtn: {
      marginTop: 10,
      textTransform: 'inherit',
      height: 48,
      fontSize: '17px !important',
      fontWeight: theme.typography.fontWeightRegular,
      color: '#fff',
      width: 180,

      [theme.breakpoints.down(920)]: {
        height: 40,
        width: '100%',
        backgroundColor: '#006997',
      },
    },
    title: {
      fontSize: 34,
      fontWeight: theme.typography.fontWeightBold,
      color: '#000000',
    },
    product: {
      display: 'flex',
      flexDirection: 'row',
      marginBottom: 32,

      [theme.breakpoints.down('md')]: {},
    },
    productInfo: {
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
    },
    containerProductName: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      marginBottom: 8,
    },
    btnClose: {
      borderRadius: 9,
      backgroundColor: '#e6e7e8',
      height: 48,
      width: 48,
      marginLeft: 30,
    },
    containerParams: {
      display: 'flex',
      flexDirection: 'row',
      gap: 64,

      [theme.breakpoints.down('md')]: {
        flexDirection: 'column',
        gap: 16,
      },
    },
    colParams: {
      display: 'flex',
      flexDirection: 'column',
      width: 190,
    },
    colParamsHeader: {
      display: 'flex',
      flexDirection: 'column',
    },
    param: {
      display: 'flex',
      flexDirection: 'row',
      marginBottom: 8,
    },
    titlePrices: {
      fontSize: 24,
      fontWeight: theme.typography.fontWeightBold,
      color: '#000000',
      marginRight: 20,
      wordBreak: 'break-word',
      overflowWrap: 'break-word',
      hyphens: 'auto',

      [theme.breakpoints.down('md')]: {
        fontSize: 17,
        marginRight: 0,
        marginBottom: 15,
      },
    },
    save: {
      textTransform: 'inherit',
      height: 48,
      fontSize: 17,
      fontWeight: theme.typography.fontWeightRegular,
      color: '#fff',
      width: 180,
      [theme.breakpoints.down('md')]: {
        height: 40,
        width: 100,
        marginTop: 10,
      },
    },
    subTitle: {
      fontSize: 18,
      fontWeight: theme.typography.fontWeightRegular,
      color: '#181c32b3',
      marginBottom: 12,
      [theme.breakpoints.down('md')]: {
        fontSize: 14,
        color: '#181c32',
      },
    },
    textField: {
      borderRadius: 4,
      backgroundColor: '#f2f2f7',
      width: 128,
      height: 48,

      [theme.breakpoints.down('md')]: {
        width: '100%',
      },
    },
    input: {
      padding: 13,
      fontSize: 18,
      color: '#181c32',
      fontWeight: theme.typography.fontWeightRegular,
      [theme.breakpoints.down('md')]: {
        fontSize: 10,
        padding: 8,
      },
    },
    numberCustomFormat: {
      padding: 0,
    },
    x: {
      fontSize: 18,
      fontWeight: theme.typography.fontWeightRegular,
      color: '#181c3280',
      margin: '0 16px',
    },
    offer: {
      display: 'flex',
      flexDirection: 'column',
      padding: 25,
      backgroundColor: '#fff',
      borderRadius: 8,
      width: '100%',
      [theme.breakpoints.down('sm')]: {
        padding: 12,
      },
    },
    offerHeader: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      marginBottom: 16,
      [theme.breakpoints.down('sm')]: {
        flexDirection: 'column',
        gap: 16,
      },
    },
    column: {
      display: 'flex',
      flexDirection: 'column',
    },
    containerFields: {
      display: 'flex',
      flexDirection: 'column',
      gap: 12,
      [theme.breakpoints.down(920)]: {
        width: '50%',
      },
    },
    containerField: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
    },
    rub: {
      color: '#7c97c0',
      fontSize: 17,
      marginLeft: 8,
      fontWeight: theme.typography.fontWeightRegular,
      // [theme.breakpoints.down('md')]: {
      //   fontSize: 18,
      // },
    },
    summ: {
      color: '#181c3280',
      fontSize: 18,
      margin: '0 16px',
      fontWeight: theme.typography.fontWeightBold,
    },
    price: {
      color: '#181c32',
      fontSize: 17,
      fontWeight: 'normal',

      // [theme.breakpoints.down('md')]: {
      //   fontSize: 17,
      // },
    },
    store: {
      color: '#181c32',
      fontSize: 14,
      fontWeight: 'normal',
      position: 'absolute',
      top: 20,
      right: 20,
      // [theme.breakpoints.down('md')]: {
      //   fontSize: 17,
      // },
    },
    priceBold: {
      color: '#181c32',
      fontSize: 17,
      fontWeight: theme.typography.fontWeightBold,
      // [theme.breakpoints.down('md')]: {
      //   fontSize: 12,
      // },
    },
    containerFieldSumm: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      height: 52,
    },
    containerColumn: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',

      [theme.breakpoints.down('md')]: {
        flexDirection: 'column',
        gap: 10,
      },
    },
    textFieldWeek: {
      borderRadius: 4,
      backgroundColor: '#f2f2f7',
      width: 52,
      [theme.breakpoints.down(920)]: {
        height: 48,
      },
    },
    onceColumn: {
      display: 'flex',
      flexDirection: 'row',

      [theme.breakpoints.down('md')]: {
        // flexDirection: 'column',
        gap: 10,
      },
    },
    containerTitle: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      [theme.breakpoints.down('sm')]: {
        flexWrap: 'wrap',
        width: '100%',
      },
    },
    containerStock: {
      display: 'flex',
      flexDirection: 'column',
    },
    textFieldCompany: {
      borderRadius: 4,
      backgroundColor: '#f2f2f7',
      width: 300,
      [theme.breakpoints.down(920)]: {
        width: '100%',
        height: 48,
      },
    },
    paginationsDots: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      width: '100%',
      maxWidth: 400,
      padding: '0 18px',
      marginLeft: 'auto',
      marginRight: 'auto',
      boxSizing: 'border-box',
      gap: 10,
    },
    dotActive: {
      flexGrow: 1,
      height: 4,
      backgroundColor: '#7C97C0',
      borderRadius: 2,
      cursor: 'pointer',
      transition: 'background-color 0.3s ease',
    },
    dot: {
      flexGrow: 1,
      height: 4,
      backgroundColor: '#EDEDF1',
      borderRadius: 2,
      cursor: 'pointer',
      transition: 'background-color 0.3s ease',
    },
    containerArrows: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      gap: 8,
      margin: '0 20px',
    },
    containerViewType: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      // gap: 8,
    },
    btnArrow: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      cursor: 'pointer',
      width: 32,
      height: 32,
      backgroundColor: '#a3a7b819',
      borderRadius: 16,
    },
    containerOffersTable: {
      display: 'flex',
      flexDirection: 'column',
      gap: 16,
    },
    containerOffersGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(3, 1fr)',
      width: '100%',
      gap: 16,

      [theme.breakpoints.down(1024)]: {
        gridTemplateColumns: 'repeat(1, 1fr)',
      },
    },
    vendorTitle: {
      fontSize: 16,
      fontWeight: 'normal',
      color: '#181c32',
      marginBottom: 15,
    },
    offerTable: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      borderRadius: 4,
      backgroundColor: '#a3a7b819',
      padding: 22,
      [theme.breakpoints.down('sm')]: {
        padding: 12,
      },
    },
    offerTableGrid: {
      display: 'flex',
      flexDirection: 'column',
      borderRadius: 4,
      backgroundColor: '#a3a7b819',
      padding: 22,
      [theme.breakpoints.down('sm')]: {
        padding: 12,
      },
    },
    containerPrices: {
      display: 'flex',
      flexDirection: 'column',
      gap: 17,
      marginRight: 40,
      minWidth: 270,
    },
    containerPricesRight: {
      display: 'flex',
      flexDirection: 'column',
      gap: 24,
      marginRight: 40,
      alignItems: 'flex-end',
    },
    countTitle: {
      fontSize: 17,
      fontWeight: theme.typography.fontWeightBold,
      color: '#181c32',
    },
    quantityTitle: {
      fontSize: 20,
      fontWeight: theme.typography.fontWeightBold,
      color: '#181c32',
      marginBottom: 24,
    },
    containerQuantity: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      padding: '0 39px',
      borderLeft: '1px solid #e6e7e8',
      borderRight: '1px solid #e6e7e8',
      width: 270,
    },
    period: {
      color: '#181c32',
      fontSize: 17,
      fontWeight: theme.typography.fontWeightRegular,
    },
    containerPricesGrid: {
      display: 'flex',
      flexDirection: 'column',
      gap: 17,
      margin: '20px 0',
    },
    priceGrid: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
    },
    gridQuantityTitle: {
      fontSize: 18,
      fontWeight: theme.typography.fontWeightRegular,
      color: '#181c32',
      marginLeft: 8,

      [theme.breakpoints.down('md')]: {
        fontSize: 15,
        marginLeft: 8,
      },
    },
    gridQuantityValue: {
      fontSize: 18,
      fontWeight: theme.typography.fontWeightBold,
      color: '#181c32',
      marginLeft: 16,
      [theme.breakpoints.down('md')]: {
        fontSize: 15,
        marginLeft: 16,
      },
    },
    iconBack: {
      transform: 'rotate(180deg)',
    },
    containerCount: {
      marginTop: 58,
      marginLeft: 20,
    },
  };
});
